import { Dialog, Loading } from "vant";
import Vue from 'vue';
import VueJsonp from "vue-jsonp";
import App from './App.vue';
import './assets/iconfont/iconfont.css';
import globalFunction from './assets/js/global_function.js'; //全局函数
import i18n from './i18n';
import router from './router';
import store from './store';
import { setUnit } from './assets/js/util2.js'

Vue.use(Dialog)
Vue.use(VueJsonp)
Vue.use(router)
Vue.use(Loading)
Vue.use(globalFunction)
Vue.config.productionTip = false
require('./assets/js/sha1.min')
require('animate.css/animate.min.css')

// Vue.prototype.mifiUrl = 'http://eqtest-lz.china-m2m.com'
// Vue.prototype.mifiUrl = 'https://192.168.0.177:8082'
// Vue.prototype.mifiUrl = 'http://eqtest-ll.china-m2m.com'
// Vue.prototype.mifiUrl = 'https://device.china-m2m.com' // 海外无需登录正式环境


Vue.prototype.$setUnit = setUnit
//改title
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

require('./assets/js/router.guard') // 全局路由守卫



const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

export default app
